var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_172415",
    transform: "translate(1117.005 916.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172412",
    transform: "translate(1377.995 831.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172411",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85287",
    d: "M-2483-1748c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12S-2476.4-1748-2483-1748z M-2483-1725.9 c-5.6,0-10.1-4.5-10.1-10.1s4.5-10.1,10.1-10.1s10.1,4.5,10.1,10.1l0,0C-2472.9-1730.4-2477.4-1725.9-2483-1725.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_172412-2",
    transform: "translate(1380.535 834.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172411-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85287-2",
    d: "M-2479.2-1743.2c-0.4-0.4-1-0.4-1.4,0c0,0,0,0,0,0l0,0l-6.2,5.9l-3-3c-0.4-0.4-1-0.4-1.4,0 c-0.4,0.4-0.4,1,0,1.4l0,0l3.6,3.7c0.4,0.4,1,0.4,1.4,0l6.9-6.6C-2478.9-1742.2-2478.9-1742.8-2479.2-1743.2 C-2479.2-1743.2-2479.2-1743.2-2479.2-1743.2L-2479.2-1743.2z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCompleted);
export default __webpack_public_path__ + "static/media/status_completed.43133684129ea12262416f26cf56cee6.svg";
export { ForwardRef as ReactComponent };